
class TwsReviewMarquee extends HTMLElement {
  connectedCallback() {
    this.group = this.querySelector('[data-marquee-group]');
    if (!this.group) return;

    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.track = this.group.parentElement;
    this.tick = this.tick.bind(this);
    this.measure = this.measure.bind(this);
    this.paused = false;
    this.measure();
    if (!this.period) return;

    this.offset = this.period;
    this.scrollLeft = this.offset;

    for (const event of ['pointerenter', 'focusin', 'pointerdown', 'touchstart']) {
      this.addEventListener(event, () => (this.paused = true), { passive: true });
    }
    for (const event of ['pointerleave', 'focusout', 'pointerup', 'touchend']) {
      this.addEventListener(event, () => (this.paused = false), { passive: true });
    }

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.group);
    }

    this.frame = requestAnimationFrame(this.tick);
  }

  disconnectedCallback() {
    if (this.frame) cancelAnimationFrame(this.frame);
    if (this.observer) this.observer.disconnect();
  }

  measure() {
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    
    this.period = this.group.offsetWidth + gap;
    if (!this.period) return;

    for (let i = 0; i < 20 && this.track.offsetWidth < this.period * 2 + this.clientWidth; i += 1) {
      this.track.append(this.track.lastElementChild.cloneNode(true));
    }

    const cards = this.group.children.length || 1;
    const seconds = Number(this.dataset.secondsPerCard) || 6;
    this.speed = this.period / (cards * seconds);
  }

  tick(now) {
    const elapsed = Math.min(now - (this.last ?? now), 100);
    this.last = now;

    if (Math.abs(this.scrollLeft - this.offset) > 1) this.offset = this.scrollLeft;

    if (!this.paused) this.offset += (this.speed * elapsed) / 1000;

    const width = this.period;
    if (width) {
      if (this.offset >= width * 2) this.offset -= width;
      else if (this.offset < width) this.offset += width;
    }

    this.scrollLeft = this.offset;
    this.frame = requestAnimationFrame(this.tick);
  }
}

if (!customElements.get('tws-review-marquee')) {
  customElements.define('tws-review-marquee', TwsReviewMarquee);
}
